export enum WorkOrderStatusEnum {

    Draft = 1,
    InProgress = 2,
    Active = 3,
    Closed = 4,
    Cancelled = 5
  
  }